import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as d, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSmallSelfView",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function f(a, t, l, u, _, e) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--small-self-view"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Small Self View",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1 3.143C1 2.301 1.611 1.5 2.5 1.5h7c.89 0 1.5.8 1.5 1.643v5.715c0 .842-.61 1.643-1.5 1.643h-7c-.889 0-1.5-.8-1.5-1.643V3.143ZM2.5 2.5c-.215 0-.5.224-.5.643v5.715c0 .42.285.642.5.642h7c.216 0 .5-.223.5-.642V3.143c0-.42-.284-.643-.5-.643h-7Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const S = /* @__PURE__ */ o(c, [["render", f]]);
export {
  S as default
};
//# sourceMappingURL=small-self-view.js.map
